/**
 * Enum representing the status of a shipment
 */
export enum ShipmentStatus {
  AvailableForPickup = 'AvailableForPickup',
  AvailableForPickupAtParcelPoint = 'AvailableForPickupAtParcelPoint',
  AvailableForPickupAtPostBox = 'AvailableForPickupAtPostBox',
  AvailableForPickupAtPostOffice = 'AvailableForPickupAtPostOffice',
  Cancelled = 'Cancelled',
  CourierPickup = 'CourierPickup',
  Delivered = 'Delivered',
  DepartedFromSender = 'DepartedFromSender',
  Error = 'Error',
  InternationalShipmentArrivedInIceland = 'InternationalShipmentArrivedInIceland',
  InternationalShipmentExpectedFromAbroad = 'InternationalShipmentExpectedFromAbroad',
  InTransit = 'InTransit',
  InTransitAbroad = 'InTransitAbroad',
  InvoiceReceived = 'InvoiceReceived',
  OnHold = 'OnHold',
  OutForHomeDelivery = 'OutForHomeDelivery',
  PreTransit = 'PreTransit',
  ReturnedToSender = 'ReturnedToSender',
  Unknown = 'Unknown',
  UnsuccessfulHomeDeliveryAttempt = 'UnsuccessfulHomeDeliveryAttempt',
}
